import React from 'react';

import { ReactComponent as Calendar } from '@portals/icons/linear/calendar.svg';
import { ReactComponent as Computing } from '@portals/icons/linear/computing.svg';
import { ReactComponent as DocumentText1 } from '@portals/icons/linear/document-text-1.svg';
import { ReactComponent as List } from '@portals/icons/linear/list.svg';
import { ReactComponent as MobileProgramming } from '@portals/icons/linear/mobile-programming.svg';
import { ReactComponent as TickSquare } from '@portals/icons/linear/tick-square.svg';
import { FieldTypeEnum } from '@portals/types';

export const TYPES_LABELS = {
  [FieldTypeEnum.Select]: 'Predefined options',
  [FieldTypeEnum.Multiselect]: 'Predefined options (Multiple)',
  [FieldTypeEnum.Textarea]: 'String',
  [FieldTypeEnum.Number]: 'Number',
  [FieldTypeEnum.Datetime]: 'Date',
  [FieldTypeEnum.Checkbox]: 'Boolean',
  [FieldTypeEnum.JSON]: 'JSON',
};

export const TYPES = [
  { value: FieldTypeEnum.Select, label: TYPES_LABELS[FieldTypeEnum.Select] },
  {
    value: FieldTypeEnum.Multiselect,
    label: TYPES_LABELS[FieldTypeEnum.Multiselect],
  },
  {
    value: FieldTypeEnum.Textarea,
    label: TYPES_LABELS[FieldTypeEnum.Textarea],
  },
  { value: FieldTypeEnum.Number, label: TYPES_LABELS[FieldTypeEnum.Number] },
  {
    value: FieldTypeEnum.Datetime,
    label: TYPES_LABELS[FieldTypeEnum.Datetime],
  },
  {
    value: FieldTypeEnum.Checkbox,
    label: TYPES_LABELS[FieldTypeEnum.Checkbox],
  },
  { value: FieldTypeEnum.JSON, label: TYPES_LABELS[FieldTypeEnum.JSON] },
];

export const TYPES_ICONS = {
  [FieldTypeEnum.Select]: {
    icon: <List />,
    color: 'cyan',
  },
  [FieldTypeEnum.Multiselect]: {
    icon: <List />,
    color: 'cyan',
  },
  [FieldTypeEnum.Number]: {
    icon: <Computing />,
    color: 'blue_accent',
  },
  [FieldTypeEnum.Textarea]: {
    icon: <DocumentText1 />,
    color: 'orange',
  },
  [FieldTypeEnum.Datetime]: {
    icon: <Calendar />,
    color: 'green',
  },
  [FieldTypeEnum.Checkbox]: {
    icon: <TickSquare />,
    color: 'red',
  },
  [FieldTypeEnum.JSON]: {
    icon: <MobileProgramming />,
    color: 'blue_gray',
  },
};
